export enum CustomerServiceType {
  IceTryggStandalone = 'IceTrygg',
  IceTryggFamilie = 'IceTryggFamily',
  IceTrygg = 'ICETRYGG_STANDALONE',
  Nettslett = 'Nettslett',
}
